import Plyr from 'plyr';

export default function plyrComponent(options = {}) {
    return {
        instance: null,
        options,
        init() {
            if (!this.$refs.player) {
                return;
            }

            this.instance = new Plyr(this.$refs.player, this.options);
        },
        destroy() {
            if (this.instance) {
                this.instance.destroy();
                this.instance = null;
            }
        }
    };
}


